import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';
import { AdhocListLine, CampaignAdhocList } from '../models/wizard.model';

export const LoadAdhocListLineColumns = createAction(
  '[Adhoc List Line]: Load Columns',
  props<{ columns: { [label: string]: string } }>(),
);

export const LoadTestAdhocListLineColumns = createAction(
  '[Test Adhoc List Line]: Test Load Columns',
  props<{ columns: { [label: string]: string } }>(),
);

export const CloseAdhocListLineModal = createAction('[Adhoc List Line]: Close Modal');

export const LoadAdhocListLineInit = createAction('[Adhoc List Line]: AdhocListLine Init');

export const LoadTestAdhocListLineInit = createAction(
  '[Test Adhoc List Line]: Test AdhocListLine Init',
  props<{ selectedCampaignAdhocList: CampaignAdhocList }>(),
);

export const LoadAdhocListLineSuccess = createAction(
  '[Adhoc List Line]: AdhocListLine Success',
  props<{ data: AdhocListLine[] }>(),
);
export const LoadAdhocListLineFailure = createAction(
  '[Adhoc List Line]: AdhocListLine Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const LoadTestAdhocListLineSuccess = createAction(
  '[Test Adhoc List Line]: Test AdhocListLine Success',
  props<{ data: AdhocListLine[] }>(),
);
export const LoadTestAdhocListLineFailure = createAction(
  '[Test Adhoc List Line]: Test AdhocListLine Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const LoadAdhocListLineCountInit = createAction('[Adhoc List Line]: AdhocListLine Count');

export const LoadTestAdhocListLineCountInit = createAction(
  '[Test Adhoc List Line]: Test AdhocListLine Count',
  props<{ selectedCampaignAdhocList: CampaignAdhocList }>(),
);

export const LoadAdhocListLineCountSuccess = createAction(
  '[Adhoc List Line]: AdhocListLine Count Success',
  props<{ count: number }>(),
);

export const LoadAdhocListLineCountFailure = createAction(
  '[Adhoc List Line]: AdhocListLine Count Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const LoadTestAdhocListLineCountSuccess = createAction(
  '[Test Adhoc List Line]: Test AdhocListLine Count Success',
  props<{ count: number }>(),
);

export const LoadTestAdhocListLineCountFailure = createAction(
  '[Test Adhoc List Line]: Test AdhocListLine Count Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const PagingChanged = createAction(
  '[Adhoc List Line]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const TestPagingChanged = createAction(
  '[Test Adhoc List Line]: Test Paging Changed',
  props<{
    paginator: Paginator;
    selectedCampaignAdhocList: CampaignAdhocList;
  }>(),
);
